(($, window) => {
    // Script loads in footer so don't need to wait for document ready

    $('#blvc-redemption[data-vcode]').first().each((index, el) => {

        new BLVCRedemption($(el));

    });
})(jQuery, window);
